import { opfsService } from './opfs.service';

export const initOPFSWorker = () => {
  if (!window.Worker) return;

  const opfsWorker = new Worker(new URL('./opfs.worker', import.meta.url), { type: 'module' });

  opfsService.setOPFSWorker(opfsWorker);
};
